import { render, staticRenderFns } from "./DispatchOrderDialog.vue?vue&type=template&id=7c5db346&"
import script from "./DispatchOrderDialog.vue?vue&type=script&lang=js&"
export * from "./DispatchOrderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports